module.exports = __webpack_public_path__ + "static/martha-stories-inventions-d04a012d6a90a6fdeafaa757fc4a3c2b.jpg";